import { BehaviorSubject, Observable, map } from 'rxjs';
import { TokenFacade } from './token.facade';
import type { SupportedTokens } from '@coin-depo-types';

export abstract class TokenBaseService implements TokenFacade {
  protected abstract supportedTokens$: BehaviorSubject<SupportedTokens[]>;

  get allCachedSupportedTokens$(): Observable<SupportedTokens[]> {
    return this.supportedTokens$.asObservable();
  }

  get cachedSupportedTokens$(): Observable<SupportedTokens[]> {
    return this.supportedTokens$.asObservable().pipe(
      map(tokens => (tokens ?? []).filter(t => t.is_active === 1))
    );
  }

  getSupportedTokensSnapshot(): SupportedTokens[] {
    return this.supportedTokens$.value;
  }

  getSupportedTokensByNameSnapshot(name: string) {
    return this.supportedTokens$.value.find(t => t.coin_name === name);
  }

  getSupportedTokensByIdSnapshot(id: string | number) {
    return this.supportedTokens$.value.find(
      t => t.coin_id === Number(id)
    );
  }

  abstract updateSupportedTokens(): Observable<unknown>;
}